const slidedata = [{
"id": 0,
"image": require("../videos/video-1.jpg"),
"video": require("../videos/Hero_Spot_1.mp4")
},
{
"id": 1,
"image": require("../videos/video-2.jpg"),
"video": require("../videos/Hero_Spot_2.mp4")
},
{
"id": 2,
"image": require("../videos/video-3.jpg"),
"video": require("../videos/Hero_Spot_3.mp4")
},
{
"id": 3,
"image": require("../videos/video-4.jpg"),
"video": require("../videos/Hero_Spot_4.mp4")
}];
    
export default slidedata;


// WEBPACK FOOTER //
// ./src/data/videocards.js